/**
 * Utility functions for attendee rendering and validation
 * Used in EventAttendees component
 */

/**
 * Template function to display attendee item with appropriate status/warning text
 * @param {Object} v - Attendee object
 * @returns {JSX.Element} Formatted attendee label
 */
export const assignToItemTemplate = (v) => {
  if (v?.status === 'ARCHIVED' && (v?.firm_user_id || !v.contact_id)) {
    return (
      <>
        {v?.firm_user_id && <i className="fas fa-user-tie me-2"></i>}
        {`${v?.label} (Inactive)`}
      </>
    );
  }
  if ((v?.firm_user_id || !v.contact_id) && v?.is_confirmed === false) {
    return (
      <>
        {v?.firm_user_id && <i className="fas fa-user-tie me-2"></i>}
        {`${v?.label} (Unconfirmed)`}
      </>
    );
  }
  if ((v?.access_level === 'client' || v?.access_level === undefined || v.contact_id) && v?.res_type !== 'user-group') {
    if (!Boolean(v?.email)) {
      return (
        <>
          {v?.firm_user_id && <i className="fas fa-user-tie me-2"></i>}
          {`${v?.label} (Email does not exist)`}
        </>
      );
    }
    if (v?.is_create_client_portal === false) {
      return (
        <>
          {v?.firm_user_id && <i className="fas fa-user-tie me-2"></i>}
          {`${v?.label} (Disabled Lawft Access)`}
        </>
      );
    }
    if (v?.is_confirmed === false) {
      return (
        <>
          {v?.firm_user_id && <i className="fas fa-user-tie me-2"></i>}
          {`${v?.label} (Unconfirmed)`}
        </>
      );
    }
  }
  return (
    <>
      {v?.firm_user_id && <i className="fas fa-user-tie me-2"></i>}
      {v?.label}
    </>
  );
};

/**
 * Check if an attendee option should be disabled in the dropdown
 * @param {Object} v - Attendee object
 * @returns {boolean} True if option should be disabled
 */
export const checkOptionDisabled = (v) => {
  if (v?.status === 'ARCHIVED' && (v?.firm_user_id || !v.contact_id)) {
    return true;
  }
  if ((v?.firm_user_id || !v.contact_id) && v?.is_confirmed === false) {
    return true;
  }
  if ((Boolean(v?.access_level) === false || v?.access_level === 'client' || v.contact_id) && v?.res_type !== 'user-group') {
    return !Boolean(v.email) || v.is_create_client_portal === false || v?.is_confirmed === false ? true : false;
  }
  return false;
};
